import { useEffect, useMemo, useState } from 'react';
import useLocalStorage from './useLocalStorage';

const buildKey = (key) => `table-page-size:${key || 'global'}`;

export default function usePersistentPageSize(key = 'global', defaultPageSize = 100, allowedOptions = [100, 250, 500]) {
  const storageKey = buildKey(key);
  const normalizedOptions = useMemo(() => {
    const options = Array.isArray(allowedOptions) && allowedOptions.length ? allowedOptions : [defaultPageSize];
    return [...new Set([...options, defaultPageSize])].sort((a, b) => a - b);
  }, [allowedOptions, defaultPageSize]);

  const existingValue = typeof window !== 'undefined' ? localStorage.getItem(storageKey) : null;
  const [hasStoredValue, setHasStoredValue] = useState(existingValue !== null);

  const fallbackValue = normalizedOptions.includes(defaultPageSize) ? defaultPageSize : normalizedOptions[0];
  const initialValue = existingValue !== null ? JSON.parse(existingValue) : fallbackValue;
  const [pageSize, setStoredPageSize] = useLocalStorage(storageKey, initialValue);

  useEffect(() => {
    if (existingValue === null && pageSize !== fallbackValue) {
      setStoredPageSize(fallbackValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setHasStoredValue(pageSize !== null && pageSize !== undefined);
  }, [pageSize]);

  const setPageSize = (value) => {
    const nextValue = Number(value);
    if (Number.isNaN(nextValue)) return;
    setHasStoredValue(true);
    const selectedValue = normalizedOptions.includes(nextValue) ? nextValue : normalizedOptions[0];
    setStoredPageSize(selectedValue);
  };

  return {
    pageSize,
    setPageSize,
    pageSizeOptions: normalizedOptions,
    hasStoredValue,
    storageKey
  };
}


